import { createContext } from 'react';

export const SelectionContext = createContext( { selectionQuarters: [ null, null ], setSelectionQuarters: ( select ) => {} } );
